module.exports = __webpack_public_path__ + "img/img.ad2c6878.png";